runOnLoad "Statistics", "*", ->

  # Get the objects that are requesting an Engine data load

  $(window).on "load-engine-stats", ->

    $engineQueryUrl         = $("#engine-stat-url")
    $engineStatPlaceholders = $(".engine-stat-placeholder")

    return if $engineQueryUrl.length != 1
    return if $engineStatPlaceholders.length == 0

    inline_error = (html) -> "<div class='inline-notice inline-error'>#{ html }</div>"

    $.ajax
      dataType: "json"
      url:      $engineQueryUrl.val()
      success: (engineStats) ->
        $.each $engineStatPlaceholders, ->
          # Get the placeholder and its parent
          $placeholder = $(@)
          $parent      = $placeholder.parent()
          # Load the correct HTML response for this type, or default to an error message
          type         = $placeholder.data("type")
          html         = engineStats[type]
          html         = inline_error("Data for type #{ type } could not be found.</h2>") unless html
          # Replace the placeholder with the new content
          preHeight    = $parent.height()
          isAbove      = $placeholder.position().top < $(window).scrollTop()
          $placeholder.replaceWith(html)
          postHeight   = $parent.height()
          heightChange = postHeight - preHeight
          # Adjust the scroll position if the replaced element is above our viewport
          $(window).scrollTop($(window).scrollTop() + heightChange) if isAbove
      error: ->
        $.each $engineStatPlaceholders, ->
          # Display an error message in all of the placeholders
          $(@).replaceWith(inline_error(t("notices.error_loading_data")))
      complete: ->
        # Let the stickynav know that the screen's height changed
        $(window).trigger("resize.stickem")

  $(window).trigger "load-engine-stats"
